module.exports = __webpack_public_path__ + "img/bb3b751fa313a4406c20ce1c4830413c.png";